import React, { useEffect } from "react";
import { handlePlotImbalances, handleRemoveAllWidget } from "../helpers";
import PropTypes from 'prop-types';
import Button from "~/components/child/ui/Button";
import TestButton from "~/components/child/tradingViewMainChart/ui/testButtom";

const RightCard = ({
  setChartIsReady,
  pair,
  imbalanceValue,
  setImbalanceValue,
  isPlotZones,
  setIsPlotZones,
  chartRef,
  dataLoading,
  setError
}) => {

  const handleTestButton = () => {
    setError(true);
   setTimeout(() => {
      setError(false);
    }, 500);
  }

  const handleInputChange = (e) => {
    const value = Number(e.target.value);
    if (!isNaN(value)) {
      setImbalanceValue(value);
    }
  };

  useEffect(() => {
    setChartIsReady(false)
    setIsPlotZones(false);
  }, [pair]);

  return (
    <div className="flex">

      <TestButton onClick={handleTestButton} position="left" className={'mr-[5px]'} tooltip="Expected an error message"/>

      <input
        value={imbalanceValue}
        onChange={handleInputChange}
        type="text"
        className={
          "outline-none text-center text-sky-70	mr-2 w-10 border-solid border-2 border-sky-key"
        }
      />


        <Button
            className={`!rounded-none w-[110px] bg-leaf-key p-2 px-4 text-sky-light text-storm-light font-bold`}
            onClick={() => !isPlotZones && handlePlotImbalances(chartRef, setIsPlotZones)}
            disabled={isPlotZones}
            isLoading={dataLoading?.zones || dataLoading?.rotations}
        >
            PLOT ZONES
        </Button>

        <Button
            className={'!rounded-none bg-infrared-key text-sky-light p-2 ml-1'}
            onClick={() => handleRemoveAllWidget(chartRef, setIsPlotZones)}
            disabled={dataLoading?.zones || dataLoading?.rotations}
        >
            CLEAR
        </Button>


    </div>
  );
};

export default RightCard;
RightCard.propTypes = {
  setChartIsReady: PropTypes.func,
  pair: PropTypes.string.isRequired,
  imbalanceValue: PropTypes.number.isRequired,
  setImbalanceValue: PropTypes.func.isRequired,
  isPlotZones: PropTypes.bool.isRequired,
  setIsPlotZones: PropTypes.func.isRequired ,
  chartRef: PropTypes.object.isRequired ,
  dataLoading: PropTypes.object.isRequired,
  setError: PropTypes.func.isRequired
};

